import { useEffect } from 'react';
import { getToken } from 'firebase/messaging';
import { useLocalStorage } from '@mantine/hooks';
import { firebaseMessaging } from '@/src/lib/firebase/config';

export function useFirebaseCloudMessagingToken() {
  const [fcmToken, setFcmToken] = useLocalStorage<string | null>({
    key: 'fcmToken',
    defaultValue: null,
  });

  const retrieveToken = async () => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
      return null;
    }

    const notificationPermission = await Notification.requestPermission();
    if (notificationPermission !== 'granted') {
      console.warn('Notification permission not granted');
      return null;
    }

    if (!firebaseMessaging) {
      console.error('Firebase messaging is not initialized');
      return null;
    }

    const token = await getToken(firebaseMessaging, {
      vapidKey: process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY,
    });
    return token;
  };

  const setFcmTokenIfNeeded = async () => {
    if (fcmToken) {
      return;
    }
    const token = await retrieveToken();
    if (token) {
      setFcmToken(token);
    }
  };

  useEffect(() => {
    setFcmTokenIfNeeded();
  }, []);

  return { token: fcmToken };
}
